var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9694 0.438965C6.06617 0.438965 0.46936 6.06956 0.46936 13.0144C0.46936 19.2902 5.03982 24.4919 11.0167 25.439V16.6504H7.84135V13.0144H11.0167V10.2438C11.0167 7.08953 12.8831 5.35017 15.7371 5.35017C17.1048 5.35017 18.5374 5.59542 18.5374 5.59542V8.68804H16.9573C15.4071 8.68804 14.9221 9.65896 14.9221 10.6538V13.0119H18.3862L17.8323 16.6478H14.9221V25.4365C20.8989 24.4945 25.4694 19.2915 25.4694 13.0144C25.4694 6.06956 19.8726 0.438965 12.9694 0.438965Z",
    fill: "#F99F00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.39d36730021dedbd15f5f33319465739.svg";
export { ForwardRef as ReactComponent };